import { useEndMeetingMutation } from '@crew/apis/meeting/meetingApis'
import { EndMeetingActionType } from '@crew/enums/domain'
import { useCallback } from 'react'

export const useEventDetailPanel = () => {
  // Get function for end meeting process
  const [endMeetingMutation, { isLoading: isLoadingEndMeeting }] =
    useEndMeetingMutation()

  // End meeting
  const endMeeting = useCallback(
    async (meetingId: string, actionType: EndMeetingActionType) => {
      // 会議終了API
      await endMeetingMutation({ meetingId, actionType })
    },
    [endMeetingMutation]
  )

  return {
    endMeeting,
    isLoadingEndMeeting,
  }
}
